import React from 'react';

import type { ProductDetailsScreenProps } from '../../navigation/AppNavigation.props';
import { ProductDetails } from './components';

export const ProductDetailsScreen = ({
  navigation,
  route,
}: ProductDetailsScreenProps) => {
  const { restaurantSlug, productSlug } = route.params;

  const handleAddLineItemToCart = React.useCallback(() => {
    navigation.replace('Bag');
  }, [navigation]);

  return (
    <ProductDetails
      restaurantSlug={restaurantSlug}
      productSlug={productSlug}
      onAddLineItemToCart={handleAddLineItemToCart}
    />
  );
};
